export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
// Keep in lockstep with the server caps in theme Config/Images.php and the
// plugin's UploadMediaRequest DTO.
export const MAX_UPLOAD_SIZE = 2 * 1024 * 1024;
export const MAX_UPLOAD_SIZE_LABEL = '2MB';

// The server-derived media_type categories a comment attachment can render as.
// Per-surface labels stay local to each component; only the canonical set is shared.
export const SUPPORTED_MEDIA_TYPES = ['image', 'audio', 'video', 'pdf'];

// Chooser hint for the comment media picker. The server's CommentMediaPolicy is
// authoritative over the extension/MIME/content tuple; this only narrows the
// file dialog to the supported matrix and never gates the upload by itself.
export const COMMENT_MEDIA_ACCEPT =
  'image/jpeg,image/png,image/gif,image/webp,image/tiff,audio/mpeg,audio/wav,audio/ogg,' +
  'video/mp4,video/webm,video/quicktime,application/pdf,' +
  '.jpg,.jpeg,.jpe,.png,.gif,.webp,.tif,.tiff,.mp3,.m4a,.wav,.ogg,.mp4,.webm,.mov,.pdf';
